
/**
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.2.2
 * @copyright  Copyright (C) 2022-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2022-03-10 (1.0.0) (jhoward)
 *        - Refactored tag from section components.
 *
 *    2023-03-23 (1.0.1) (jhoward)
 *        - Add support for "Prime" tag in <menu-tag>.
 *        - Add support for "Fancy Glass" tag in <menu-tag>.
 *        - Add support for "Ice Glass" tag in <menu-tag>.
 *        - Add support for "Martini Glass" tag in <menu-tag>.
 *        - Add support for "Mason Jar" tag in <menu-tag>.
 *        - Add support for "Sup Glass" tag in <menu-tag>.
 *
 *    2023-03-27 (1.0.2) (jhoward)
 *        - Make the new tags in <menu-tag> use a 96x96px image rather than 128x128px.
 *        - Make the "Prime" tag in <menu-tag> use a 256x256px image.
 *
 *    2023-04-24 (1.1.0) (jhoward)
 *      - Add TypeScript support to <menu-tag>.
 *
 *    2023-10-18 (1.1.1) (zsahs)
 *      - Add support for "Coupe" tag in <menu-tag>.
 *
 *    2024-04-29 (1.1.2) (jhoward)
 *      - Add aria-label attribute in <menu-tag>.
 *
 *    2024-07-16 (1.2.0) (jhoward)
 *      - Give all <menu-tag> a generic .menu--tag class rather than different classes based on visual/textual menu containers.
 *
 *    2024-08-28 (1.2.1) (jhoward)
 *      - Fix some tag CSS for tags with circles around them in <menu-tag>.
 *
 *    2025-02-10 (1.2.2) (jhoward)
 *      - Add "Prime Black and White" tag to <menu-tag>.
 */

import {defineComponent, PropType} from "vue";
import {MenuTagModel} from "./defs";


export default defineComponent({
  name: 'menu-tag',
  props: {
    tag: {
      type: Object as PropType<MenuTagModel>,
      required: true
    },
    menuType: {
      type: String,
      default: 'visual',
      validator(value: string) {
        return ['visual', 'textual'].includes(value);
      }
    },
  },
  computed: {
    containerClasses(): {[key: string]: boolean} {
      const classes: {[key: string]: boolean} = {
        'tooltip-dock-bottom': this.menuType === 'visual',
        'tooltip-dock-right': this.menuType === 'textual',
      };
      classes[this.tag.mt_icon_class] = true;
      return classes;
    }
  }
})
